import { useState } from 'react';
import { useFamilyStore } from '@/store/familyStore';
import { PersonalInfoRequest } from '@/types';
import { api } from '@/lib/api/client';

export function usePersonalInfoRequests() {
  const { 
    personalInfoRequests, 
    addPersonalInfo,
    updatePersonalInfoRequestStatus,
    fetchRequests
  } = useFamilyStore();
  const [selectedRequest, setSelectedRequest] = useState<PersonalInfoRequest | null>(null);
  const [rejectingRequestId, setRejectingRequestId] = useState<string | null>(null);

  const handleApprove = async (request: PersonalInfoRequest) => {
    try {
      // Send approval to backend
      await api.post(`api/requests/${request.id}/approve`, { type: 'info' });
      
      // Add personal info locally
      addPersonalInfo({
        id: Math.random().toString(36).substr(2, 9),
        fullName: request.full_name,
        description: request.description,
        photoUrl: request.photo_url,
        resumeUrl: request.resume_url,
        isResumePublic: request.is_resume_public === 1,
        createdAt: Date.now(),
        updatedAt: Date.now()
      });

      // Update request status locally
      updatePersonalInfoRequestStatus(request.id, 'approved');
      
      // Refresh requests from backend
      await fetchRequests();
      
      // Close dialog
      setSelectedRequest(null);
    } catch (error) {
      console.error('Error approving info request:', error);
    }
  };

  const handleReject = async (requestId: string) => {
    try {
      // Send rejection to backend
      await api.post(`api/requests/${requestId}/reject`, { type: 'info' });
      
      // Update request status locally
      updatePersonalInfoRequestStatus(requestId, 'rejected');
      
      // Refresh requests from backend
      await fetchRequests();
      
      // Close dialog
      setRejectingRequestId(null);
    } catch (error) {
      console.error('Error rejecting info request:', error);
    }
  };

  return {
    requests: personalInfoRequests,
    selectedRequest,
    rejectingRequestId,
    setSelectedRequest,
    setRejectingRequestId,
    handleApprove,
    handleReject
  };
}